import React, { FunctionComponent } from 'react';
import { Checkbox } from 'antd';
import { FormField, FormFieldProps } from './form-field';

export const FormCheckbox: FunctionComponent<
  Omit<FormFieldProps, 'render'> & {
    checkboxText?: React.ReactNode | string;
    onChange?: (arg1: boolean) => void;
    style?: React.CSSProperties;
  }
> = ({ checkboxText, onChange, ...formFieldProps }) => {
  return (
    <FormField
      {...formFieldProps}
      render={({ field }) => {
        return (
          <Checkbox
            className="form-field__checkbox"
            checked={field.value}
            {...field}
            onChange={(e) => {
              if (onChange) {
                onChange(e.target.checked);
              } else {
                field.onChange(e.target.checked);
              }
            }}
            style={formFieldProps.style || {}}
          >
            {checkboxText}
          </Checkbox>
        );
      }}
    />
  );
};
